import BaseStore from '../../BaseStore';
import WorkOrderModel from "../../../models/Maintenance/WorkOrder/WorkOrderModel";
import { observable, action, computed, toJS } from 'mobx';
import { token } from "../../../libs/localStorage";
import { random_rgba } from "../../../utils";
import moment from "moment";
import _ from "lodash";

class WorkOrderStore extends BaseStore {
  ticketStore;
  stationStore;
  workOrderStatusStore;
  workOrderStore;
  priorityStore;
  maintenanceTypeStore;
  userStore;
  locationStore;

  @observable followers = [];
  @observable workOrder = null;
  @observable workOrder_logs = [];
  @observable tasks = [];

  @observable view_archived = false;
  @observable assigned_to_all = false;

  @observable viewBy = 1;

  viewByOptions = [{ id: 1, name: 'Status' }, { id: 2, name: 'Priority' }, { id: 3, name: 'Type' }, { id: 4, name: 'Assigned To' }];

  @observable show = null;
  @observable selectedMarker = null;

  @observable timeRange = [];
  @observable selectedTime = 0;
  @observable filters = {
    date_from: null,
    date_to: null,
    filter_by_location: false,
    location_id: 0,
    location_type_id: 0,
  }
  @observable selectedStations = [];

  @action onChangeFilters = (key, e) => {
    this.filters[key] = e.target.value;
    if (key === 'location_type_id') this.filters.location_id = 0;
    this.selectedMarker = null;
  }
  @action onChangeSelectedStations = items => {
    this.selectedStations = items;
    this.selectedMarker = null;
  }

  constructor({
    workOrderStatusStore,
    stationStore,
    priorityStore,
    maintenanceTypeStore,
    userStore,
    transportLayer,
    ticketStore,
    locationStore,
  }) {
    super(WorkOrderModel, transportLayer);

    this.workOrderStatusStore = workOrderStatusStore;
    this.stationStore = stationStore;
    this.priorityStore = priorityStore;
    this.maintenanceTypeStore = maintenanceTypeStore;
    this.userStore = userStore;
    this.ticketStore = ticketStore;
    this.locationStore = locationStore;
  }

  @computed get filteredWorkOrders() {
    const workOrders = this.items.reduce((acc, work_order) => {
      if (!this.view_archived && work_order.archived) return acc;
      if (!this.assigned_to_all && +work_order.assigned_to !== +token.getDecoded().id) return acc;

      if (!!this.filters.date_from) {
        if (!this.filters.date_to && !moment(work_order.creation_date).isSameOrAfter(this.filters.date_from)) return acc;
        if (!!this.filters.date_to && !moment(work_order.creation_date).isBetween(this.filters.date_from, this.filters.date_to)) return acc;
      }

      let isIncludedByStationFilter = true;
      if (work_order.station) work_order.station.forEach(item => {
        if (!this.filters.filter_by_location) isIncludedByStationFilter = isIncludedByStationFilter && this.selectedStations.includes(+item.id);
        if (this.filters.filter_by_location && this.filters.location_type_id !== 0 && this.filters.location_id !== 0) {
          const station = this.stationStore.findById(item.id);
          isIncludedByStationFilter = isIncludedByStationFilter && this.locationStore.isPartOf(station.location_id, this.filters.location_id);
        }
      });

      if (!isIncludedByStationFilter) return acc;

      if (!!this.viewBy && !!this.show) {
        switch (+this.viewBy) {
          case 1: if (+work_order.status_id !== +this.show) return acc; else break;
          case 2: if (+work_order.priority_id !== +this.show) return acc; else break;
          case 3: if (+work_order.maintenance_type !== +this.show) return acc; else break;
          case 4: if (+work_order.assigned_to !== +this.show) return acc; else break;
          default: break;
        }
      }

      acc.push(work_order);

      return acc;
    }, []);

    workOrders.forEach(wo => {
      const existingWorkOrderWithColor = workOrders.find(w => +w.assigned_to === +wo.assigned_to && w.color);

      if (existingWorkOrderWithColor)
        wo.color = existingWorkOrderWithColor.color;
      else
        wo.color = random_rgba();
    });

    return workOrders;
  }

   @computed get filteredWorkOrders2() {
    const workOrders = this.items.reduce((acc, work_order) => {
      if (!this.view_archived && work_order.archived) return acc;
      if (!this.assigned_to_all_trip && +work_order.assigned_to !== +token.getDecoded().id) return acc;

      // if (!!this.filters.date_from) {
      //   if (!this.filters.date_to && !moment(work_order.creation_date).isSameOrAfter(this.filters.date_from)) return acc;
      //   if (!!this.filters.date_to && !moment(work_order.creation_date).isBetween(this.filters.date_from, this.filters.date_to)) return acc;
      // }

      // let isIncludedByStationFilter = true;
      // if (work_order.station) work_order.station.forEach(item => {
      //   // if (!this.filters.filter_by_location) isIncludedByStationFilter = isIncludedByStationFilter && this.selectedStations.includes(+item.id);
      //   if (this.filters.filter_by_location && this.filters.location_type_id !== 0 && this.filters.location_id !== 0) {
      //     const station = this.stationStore.findById(item.id);
      //     isIncludedByStationFilter = isIncludedByStationFilter && this.locationStore.isPartOf(station.location_id, this.filters.location_id);
      //   }
      // });

      // if (!isIncludedByStationFilter) return acc;

      if (!!this.viewBy && !!this.show) {
        switch (+this.viewBy) {
          case 1: if (+work_order.status_id !== +this.show) return acc; else break;
          case 2: if (+work_order.priority_id !== +this.show) return acc; else break;
          case 3: if (+work_order.maintenance_type !== +this.show) return acc; else break;
          case 4: if (+work_order.assigned_to !== +this.show) return acc; else break;
          default: break;
        }
      }

      acc.push(work_order);

      return acc;
    }, []);


    workOrders.forEach(wo => {
      const existingWorkOrderWithColor = workOrders.find(w => +w.assigned_to === +wo.assigned_to && w.color);

      if (existingWorkOrderWithColor)
        wo.color = existingWorkOrderWithColor.color;
      else
        wo.color = random_rgba();
    });

    return workOrders;
  }

  @computed get assignees() {
    return this.filteredWorkOrders.reduce((acc, wo) => {
      if (!wo.assigned_to) return acc;
      const existingAssignee = acc.find(a => +a.id === +wo.assigned_to);
      if (!existingAssignee) acc.push(Object.assign({}, wo.assigned_to_user, { id: wo.assigned_to, color: wo.color }));
      return acc;
    }, []);
  }

  @action onChangeViewSwitch(key) {
    this[key] = !this[key];
  };

   @action onChangeViewSwitch2(key) {
    this[key] = !this[key];
  };

  @computed get sortedWorkOrderLogs() {
    return this.workOrder_logs.sort((a, b) => new Date(a.log_date).valueOf() < new Date(b.log_date).valueOf() ? 1 : -1)
  }

  @computed get getCheckedFollowers() {
    return this.followers.filter(item => !!item.checked);
  }

  fetchWorkOrderById(id) {
    this._fetchById(id).then(workOrder => {
      this.followers = workOrder.followers ? Object.assign(workOrder.followers, { checked: false }) : [];
      this.workOrder_logs = workOrder.logs || [];
      this.tasks = workOrder.tasks || [];
      delete workOrder.followers;
      delete workOrder.logs;
      delete workOrder.tasks;
      this.workOrder = workOrder;
    })
  }

  @action addWorkOrderFollower(work_order_id, { user_id, email, name }) {
    this.transportLayer.follower.create(work_order_id, { user_id }).then(() => {
      this.followers.push({
        work_order_id,
        user_id,
        email,
        name
      })
    })
  }

  @action removeWorkOrderFollower(workOrder_id, user_id) {
    this.transportLayer.follower.remove(workOrder_id, user_id).then(() => {
      this.followers = this.followers.filter(item => +item.work_order_id !== +workOrder_id || +item.user_id !== +user_id)
    })
  }

  @action pushLog(log, file) {
    log.attachment_file = file;
    log.text = log.message.text;
    delete log.message;
    this.workOrder_logs.push(log)
  }

  findByTaskId(id) {
    return Object.assign({}, this.tasks.find(item => +item.id === +id))
  }

  @action createTaskItem(workOrder_id, json) {
    return this.transportLayer.task.create(workOrder_id, json).then(id => {
      this.tasks.push(Object.assign(json, { id }));
      return id;
    })
  }

  @action removeTaskItem(workOrder_id, task_id) {
    if (task_id instanceof Array) return this.removeMultipleTaskItem(workOrder_id, task_id);
    this.transportLayer.task.remove(workOrder_id, task_id).then(() => {
      this.tasks = this.tasks.filter(item => +item.id !== +task_id);
    })
  }

  @action removeMultipleTaskItem(workOrder_id, task_ids) {
    this.transportLayer.task.removeMultiple(workOrder_id, task_ids).then(() => {
      this.tasks = this.tasks.filter(item => task_ids.indexOf(item.id) === -1);
    })
  }

  @action updateTaskItem(workOrder_id, task_id, json) {
    return this.transportLayer.task.update(workOrder_id, task_id, json).then(() => {
      Object.keys(json).map(key => {
        let item = this.tasks.filter(item => +item.id === +task_id)[0];
        item[key] = json[key];
      });
    });
  }

  @action clearWorkOrderView() {
    this.workOrder_logs = [];
    this.followers = [];
    this.workOrder = null;
    this.tasks = [];
  }

  @action setDateAndTimeRange = (workOrders) => {
    if (workOrders.length > 1) {
      let timeRange = {};

      workOrders.forEach(wo => {
        let date = moment(wo.scheduled_date).seconds(0).valueOf();

        if (!this.timeRange[date]) timeRange = Object.assign(timeRange, { [date]: wo.scheduled_date });
      })

      this.timeRange = Object.keys(timeRange).sort((a, b) => +a < +b ? -1 : 1).map((key, index) => ({
        value: index,
        epoch: key,
        date: timeRange[key]
      }));
    }
  }

  @action setSelectedTime = (value) => {
    this.selectedTime = value;
  };

  @action onChangeViewBy = value => {
    this.viewBy = value;
    this.show = null;
  };
  @action onChangeShow = value => {
    if (value === this.show) this.show = null;
    else this.show = value;
  };

  @action onMarkerOver = marker => this.selectedMarker = marker.station_id;

  getMarkers() {
    const statusItems = this.workOrderStatusStore.items,
      priorityItems = this.priorityStore.items,
      maintenanceTypeItems = this.maintenanceTypeStore.items,
      workOrderItems = this.filteredWorkOrders,
      users = this.userStore.items;

    let selectedWOItems = workOrderItems;


    if (this.timeRange && this.timeRange.length > 1) {
      const selectedTime = this.timeRange[this.selectedTime];

      if (selectedTime)
        selectedWOItems = workOrderItems.filter(t => new Date(t.scheduled_date).getTime() === new Date(selectedTime.date).getTime())
    }

    let markers = [];

    selectedWOItems.forEach((wo) => {
      wo.station && wo.station.forEach(s => {
        const station = this.stationStore.findById(s.id);
        const existingMarker = markers.find(m => +m.station_id === +s.id);

        if (existingMarker) {
          const status = statusItems.find(item => +item.id === +wo.status_id),
            priority = priorityItems.find(item => +item.id === +wo.priority_id),
            user = users.find(item => +item.id === +wo.assigned_to),
            type = maintenanceTypeItems.find(item => +item.id === +wo.maintenance_type);

          const work_order = { ...wo.asJson };
          existingMarker.work_orders.push(Object.assign(work_order, { status, priority, type, user, color: wo.color }));

          let color = '';

          switch (+this.viewBy) {
            case 1: color = !!this.show ? _.result(existingMarker.work_orders.find(item => +item.status_id === +this.show), 'status.color', '') : _.result(existingMarker.work_orders, '[0].status.color'); break;
            case 2: color = !!this.show ? _.result(existingMarker.work_orders.find(item => +item.priority_id === +this.show), 'priority.color', '') : _.result(existingMarker.work_orders, '[0].priority.color'); break;
            case 3: color = !!this.show ? _.result(existingMarker.work_orders.find(item => +item.maintenance_type === +this.show), 'type.color', '') : _.result(existingMarker.work_orders, '[0].type.color'); break;
            case 4: color = !!this.show ? _.result(existingMarker.work_orders.find(item => +item.assigned_to === +this.show), 'color', '') : _.result(existingMarker.work_orders, '[0].color'); break;
            default: color = ''; break;
          }

          existingMarker.color = color;
        } else {
          let status = statusItems.find(item => +item.id === +wo.status_id),
            priority = priorityItems.find(item => +item.id === +wo.priority_id),
            user = users.find(item => +item.id === +wo.assigned_to),
            type = maintenanceTypeItems.find(item => +item.id === +wo.maintenance_type);

          const work_order = { ...wo.asJson };
          const work_orders = [Object.assign(work_order, { status, priority, type, color: wo.color, user })];

          let color = '';

          switch (+this.viewBy) {
            case 1: color = !!this.show ? _.result(work_orders.find(item => +item.status_id === +this.show), 'status.color', '') : _.result(work_orders, '[0].status.color'); break;
            case 2: color = !!this.show ? _.result(work_orders.find(item => +item.priority_id === +this.show), 'priority.color', '') : _.result(work_orders, '[0].priority.color'); break;
            case 3: color = !!this.show ? _.result(work_orders.find(item => +item.maintenance_type === +this.show), 'type.color', '') : _.result(work_orders, '[0].type.color'); break;
            case 4: color = !!this.show ? _.result(work_orders.find(item => +item.assigned_to === +this.show), 'color', '') : _.result(work_orders, '[0].color'); break;
            default: color = ''; break;
          }

          if (station) {
            markers.push(Object.assign(station.asJson, {
              station_id: station.id,
              station_name: station.name,
              work_orders,
              color,
              duration: ''
            }));
          }
        }
      });
    });

    return markers;
  }

   getMarkers2(workOrder) {
    const statusItems = this.workOrderStatusStore.items,
      priorityItems = this.priorityStore.items,
      maintenanceTypeItems = this.maintenanceTypeStore.items,
      workOrderItems = workOrder || this.filteredWorkOrders2,
      users = this.userStore.items;

    let selectedWOItems = workOrderItems;

    if (this.timeRange && this.timeRange.length > 1) {
      const selectedTime = this.timeRange[this.selectedTime];

      if (selectedTime)
        selectedWOItems = workOrderItems.filter(t => new Date(t.scheduled_date).getTime() === new Date(selectedTime.date).getTime())
    }

    let markers = [];

    selectedWOItems.forEach((wo) => {
      wo.station && wo.station.forEach(s => {
        const station = this.stationStore.findById(s.id);
        const existingMarker = markers.find(m => +m.station_id === +s.id);

        if (existingMarker) {
          const status = statusItems.find(item => +item.id === +wo.status_id),
            priority = priorityItems.find(item => +item.id === +wo.priority_id),
            user = users.find(item => +item.id === +wo.assigned_to),
            type = maintenanceTypeItems.find(item => +item.id === +wo.maintenance_type);

          const work_order = { ...wo.asJson };
          existingMarker.work_orders.push(Object.assign(work_order, { status, priority, type, user, color: wo.color }));

          let color = '';

          switch (+this.viewBy) {
            case 1: color = !!this.show ? _.result(existingMarker.work_orders.find(item => +item.status_id === +this.show), 'status.color', '') : _.result(existingMarker.work_orders, '[0].status.color'); break;
            case 2: color = !!this.show ? _.result(existingMarker.work_orders.find(item => +item.priority_id === +this.show), 'priority.color', '') : _.result(existingMarker.work_orders, '[0].priority.color'); break;
            case 3: color = !!this.show ? _.result(existingMarker.work_orders.find(item => +item.maintenance_type === +this.show), 'type.color', '') : _.result(existingMarker.work_orders, '[0].type.color'); break;
            case 4: color = !!this.show ? _.result(existingMarker.work_orders.find(item => +item.assigned_to === +this.show), 'color', '') : _.result(existingMarker.work_orders, '[0].color'); break;
            default: color = ''; break;
          }

          existingMarker.color = color;
        } else {
          let status = statusItems.find(item => +item.id === +wo.status_id),
            priority = priorityItems.find(item => +item.id === +wo.priority_id),
            user = users.find(item => +item.id === +wo.assigned_to),
            type = maintenanceTypeItems.find(item => +item.id === +wo.maintenance_type);

          const work_order = { ...wo.asJson };
          const work_orders = [Object.assign(work_order, { status, priority, type, color: wo.color, user })];

          let color = '';

          switch (+this.viewBy) {
            case 1: color = !!this.show ? _.result(work_orders.find(item => +item.status_id === +this.show), 'status.color', '') : _.result(work_orders, '[0].status.color'); break;
            case 2: color = !!this.show ? _.result(work_orders.find(item => +item.priority_id === +this.show), 'priority.color', '') : _.result(work_orders, '[0].priority.color'); break;
            case 3: color = !!this.show ? _.result(work_orders.find(item => +item.maintenance_type === +this.show), 'type.color', '') : _.result(work_orders, '[0].type.color'); break;
            case 4: color = !!this.show ? _.result(work_orders.find(item => +item.assigned_to === +this.show), 'color', '') : _.result(work_orders, '[0].color'); break;
            default: color = ''; break;
          }

          if (station) {
            markers.push(Object.assign(station.asJson, {
              station_id: station.id,
              station_name: station.name,
              work_orders,
              color,
              duration: ''
            }));
          }
        }
      });
    });
    return markers;
  }

  @computed get infoTableColumn() {
    switch (+this.viewBy) {
      case 1: return [{ key: 'color', label: '' }, { key: 'caption', label: 'Status' }, { key: 'number', label: '#' }];
      case 2: return [{ key: 'color', label: '' }, { key: 'caption', label: 'Priority' }, { key: 'number', label: '#' }];
      case 3: return [{ key: 'color', label: '' }, { key: 'caption', label: 'Type' }, { key: 'number', label: '#' }];
      case 4: return [{ key: 'color', label: '' }, { key: 'name', label: 'Assigned To' }, { key: 'number', label: '#' }];
      default: return []
    }
  }
}

export default WorkOrderStore;



// WEBPACK FOOTER //
// ./src/stores/Maintenance/WorkOrder/WorkOrderStore.js